// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1imJK","actions":"GroupTable_actions__2YlQa","deleteModalFooter":"GroupTable_deleteModalFooter__QFJvI"};